import React from "react";
import { useTranslation } from "react-i18next";
import "./NotificationBanner.css";

/**
 * NotificationBanner Component
 *
 * Displays a banner prompting users to enable push notifications.
 * Provides links to enable notifications and view browser-specific guides.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to show the banner
 * @param {Function} props.onEnableNotifications - Callback to enable notifications
 * @param {Function} props.onShowGuide - Callback to show notification guide
 * @param {Function} props.onDismiss - Callback to dismiss the banner
 * @returns {JSX.Element|null} NotificationBanner component or null if not shown
 */
const NotificationBanner = ({
  show,
  onEnableNotifications,
  onShowGuide,
  onDismiss,
  isDenied,
}) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <div
      className="notification-banner"
      style={{ bottom: "0px", top: "unset" }}
    >
      <div className="notification-banner-content">
        <span className="notification-banner-text">
          {isDenied ? t("notificationsBlocked") : t("appNeedsPermission")}
        </span>

        <div className="notification-banner-actions">
          {!isDenied && (
            <button
              className="notification-banner-link primary"
              onClick={onEnableNotifications}
            >
              {t("enablePushNotifications")}
            </button>
          )}

          <button
            className="notification-banner-link secondary"
            onClick={onShowGuide}
          >
            {t("pusnNotificationGuide")}
          </button>

          {onDismiss && (
            <button
              className="notification-banner-dismiss"
              onClick={onDismiss}
              aria-label={t("dismiss")}
            >
              ×
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationBanner;
